<style lang="scss" scoped>
  .loading {
    padding: 40px;
  }
  .error {
    padding-top: 15px;
    font-size: 14px;
  }
</style>


<template>
  <div class="full flex-c">
    <bar-loader color="#9B1C1F"/>
    <div class="error">{{error}}</div>
  </div>
</template>


<script>
import { BarLoader } from '@saeris/vue-spinners';
import { get } from 'vuex-pathify';
import api from '@/api';


export default {
  name: 'loading',
  components: {
    BarLoader
  },
  created() {
    api.load();
  },
  computed: {
    error: get('error')
  }
};
</script>
